import { render, staticRenderFns } from "./login-layout.vue?vue&type=template&id=48d1d208&scoped=true"
import script from "./login-layout.vue?vue&type=script&lang=js"
export * from "./login-layout.vue?vue&type=script&lang=js"
import style0 from "./login-layout.vue?vue&type=style&index=0&id=48d1d208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1d208",
  null
  
)

export default component.exports